import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { AssignmentGroupConstants } from './assignment-group-constants';
import { AssignmentGroupInteractionService } from './services/assignment-group-interaction.service';
import { AssignmentGroupDetails } from './models/assignment-group-details';
import { AssignmentGroupService } from './services/assignment-group.service';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { SpinnerService } from '../../shared/services/spinner.service';

@Component({
  selector: 'app-assignment-group',
  templateUrl: './assignment-group.component.html',
  styleUrls: ['./assignment-group.component.scss'],
})
export class AssignmentGroupComponent {
  assignmentGroupToEdit!: AssignmentGroupDetails;
  isAssignmentGroupSliderOpen = false;
  topBarTitle: string = AssignmentGroupConstants.AssignmentGroupTitle;
  addAssignmentTitle: string =
    AssignmentGroupConstants.CreateAssignmentGroupButtonTitle;
  treeSelectPlaceHolderText: string = AssignmentGroupConstants.Scope_Tree_Select_PlaceHolder;
  accessToAGs = false;
  accessToAGsErrorMessage!: string;

  labsites: any = [];
  treeData: TreeNode[] = [];
  valueField: string = 'value';
  labelField: string = 'name';
  selectedScope: any;
  showSpinner: boolean = false;

    constructor(private eqmsScopeManagementService: EqmsScopeManagementService,
    private assignmentGroupInteractionService: AssignmentGroupInteractionService,
    private assignmentGroupService:AssignmentGroupService, private spinner: SpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.getSpinnerState().subscribe((state) => this.showSpinner = state.isLoading);
    this.checkAGsAuthorization();
  }

  checkAGsAuthorization(){
    this.assignmentGroupService.getAGsAuthorization().subscribe({
      next: (value) => {
          this.accessToAGs = true;
          this.loadEQMSScope();
      },
      error: (err) => {
        if(err.status === LabelConstants.Forbidden_StatusCode){
          this.accessToAGsErrorMessage = err.error.detail;
          this.accessToAGs = false;
        }
      }
    })
  }

  loadEQMSScope = () => {
    this.assignmentGroupService.getEQMSScopeForAssignmentGroups().subscribe((eQMSScope) => {
        this.treeData = this.assignmentGroupService.getEQMSScopeTreeNodes(eQMSScope);
    });
  }

  addAssignmentGroup() {
    this.assignmentGroupInteractionService.seteQMSScope = this.selectedScope;
    this.isAssignmentGroupSliderOpen = !this.isAssignmentGroupSliderOpen;
  }
  editAssignmentGroupSlider = (assignmentGroup: AssignmentGroupDetails) => {
    this.assignmentGroupToEdit = {...assignmentGroup};
    this.assignmentGroupInteractionService.seteQMSScope = this.selectedScope;
    this.isAssignmentGroupSliderOpen = !this.isAssignmentGroupSliderOpen;
  }
  closeAssignmentGroupSlider(isSliderActive: boolean) {
    this.isAssignmentGroupSliderOpen = isSliderActive;
  }

  NoAccessToAssignmentGroupErrorMessage() : string{
    if(!this.accessToAGs)
      return this.accessToAGsErrorMessage;
    
    return '';
  }

  ngOnDestroy(): void {
    this.assignmentGroupService.clearEQMSScopeCache();
  }
}
